package com.iregained.site.components.sections.product.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val ElevatedClearanceCardStyle = CssStyle {
    val palette = colorMode.toSitePalette()

    base {
        Modifier
            // A rich, dark teal drop shadow to make the card "float"
            .boxShadow(0.px, 15.px, 35.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.25f)).transition(
                Transition.of("transform", 0.3.s), Transition.of("box-shadow", 0.3.s)
            )
    }
    hover {
        Modifier.translateY((-4).px) // Subtle float toward the user on hover
            .boxShadow(0.px, 20.px, 45.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.35f))
    }
}